import React from 'react';
export function PainPoints() {
  const points = ['El domingo a la noche buscando cómo explicar el FCR o el ciclo del nitrógeno con un lenguaje que tus alumnos entiendan sin dormirse.', 'Estudiantes que salen de la escuela sin saber distinguir una trucha de un bagre ni calcular la tasa de alimentación.', 'Material que no se corresponde con las especies, los sistemas ni la realidad productiva de nuestras provincias.', 'Fines de semana enteros armando planillas, tablas y evaluaciones que nadie te enseñó a diseñar.', 'Esa sensación de que estás improvisando en un sector donde una mala decisión técnica hace que se muera todo el lote.'];
  return <section className="py-7 px-4 bg-brand-cream" data-id="element-130">
      <div className="max-w-3xl mx-auto" data-id="element-131">
        <h2 className="text-xl md:text-3xl font-display font-bold text-brand-navy text-center uppercase leading-tight mb-4" data-id="element-132">
          Si enseñás{' '}
          <span className="green-highlight" data-id="element-133">
            Acuicultura, Piscicultura o Producción Acuícola
          </span>
          , esto te va a sonar muy familiar:
        </h2>

        <div className="bg-white border-2 border-brand-navy rounded-lg p-4 md:p-5 brunson-shadow mb-4" data-id="element-134">
          <ul className="space-y-2" data-id="element-135">
            {points.map((p, i) => <li key={i} className="flex items-start gap-2" data-id="element-136">
                <span className="text-brand-red text-lg leading-none mt-0.5" data-id="element-137">
                  ❌
                </span>
                <p className="text-sm md:text-base text-brand-ink font-medium leading-snug" data-id="element-138">
                  {p}
                </p>
              </li>)}
          </ul>
        </div>

        <p className="text-center text-lg md:text-2xl font-display font-bold text-brand-orange uppercase" data-id="element-139">
          ¿Cuántos domingos más vale tu tiempo libre?
        </p>
      </div>
    </section>;
}